import Phaser from "phaser";
import BootGame, { GameController } from "./bootGame";
import TurnBasedInputPlugin from "./plugins/TurnBasedInputPlugin";
import { DEV_MODE } from "./constants";
import { WorldMapScene } from "./WorldMapScene";
import IntroCardScene from "./scenes/IntroCardScene";
import TitleScene from "./scenes/TitleScene";

export default {
  type: Phaser.WEBGL,
  width: 128,
  height: 128,
  pixelArt: true,
  parent: DEV_MODE ? "game-container" : "game-container-regular",
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  title: "Phaser 3 with Parcel 📦",
  url: "https://github.com/samme/phaser-parcel",
  banner: {
    text: "white",
    background: ["#FD7400", "#FFE11A", "#BEDB39", "#1F8A70", "#004358"],
  },
  scene: [BootGame, TitleScene, IntroCardScene, WorldMapScene, GameController],
  plugins: {
    global: [TurnBasedInputPlugin.registerConfig()],
  },
};
